import React, { useEffect, useState } from 'react';
import SimpleHero from '../../components/SimpleHero/SimpleHero';
import FeatureList from '../../components/Minimal/FeatureList';
import bank from '../../assets/images/terms.png';
import './Termsofuse.css';

const DOC_CODE = 'GN-T&C-2024';
const WEBSITE_URL = 'https://gnbank.net';

const Termsofuse = () => {
  const [code, setCode] = useState('');
  const generateCode = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let result = "GN-T&C-";
    for (let i = 0; i < 8; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCode(result);
   
  };
  useEffect(() => {
    generateCode();
  }, []);

  useEffect(() => {
    document.body.classList.add('terms-print-page');
    return () => document.body.classList.remove('terms-print-page');
  }, []);

  const handlePrint = () => window.print();

  return (
    <div className="terms-page">
      {/* Screen-only: hero, features, print button */}
      <div className="terms-no-print">
        <SimpleHero
          title="Terms, Disclosures, Agreements,  And Conditions."
          subtitle={`These Terms of Use ("Terms"), Disclosures, Agreements, Conditions,  govern your access to and use of our mobile application, online banking platform, products, and services (collectively, the "Services"). By accessing or using our Services, you agree to be bound by these Terms.`}
          variant="sofi"
          imageSrc={bank}
          imageAlt="Terms And Conditions"
          imageOn="right"
          tiltImage
          badges={["Terms, Agreements, Disclosures,  And Conditions"]}
        />
        <FeatureList
          items={[
            { title: 'Data minimization', desc: 'Only the info required to provide services.' },
            { title: 'Security‑first', desc: 'Encryption, monitoring, and access controls.' },
            { title: 'Your choices', desc: 'Manage communications and sharing preferences.' },
            { title: 'Fees & Disclosures', desc: 'Fees, Rates and Charges.' },
          ]}
        />
        <div className="gn-container terms-print-actions">
          <button type="button" className="btn btn-gn-primary" onClick={handlePrint} aria-label="Print or save as PDF">
            Print / Export as PDF
          </button>
        </div>
      </div>

      {/* Print-only: document header */}
      <div className="terms-print-header" aria-hidden="true">
        <strong>Terms, Disclosures, Agreements &amp; Conditions</strong>
        <span className="terms-print-code">{code} -  Rev. {new Date().getFullYear()}</span>
      </div>

      <section className="section terms-print-body">
        <div className="gn-container">
          <div className="terms-content">
            <p className="terms-intro">
              Welcome to GN Bank. These Terms of Use ("Terms"), Disclosures, and Agreements,  govern your access to and use of our mobile application, online banking platform, products, and services. By accessing or using our Services, you agree to be bound by these Terms.
            </p>

            <div className="terms-section">
              <h3>1. Eligibility</h3>
              <p>To use our Services, you must:</p>
              <ul>
                <li>Be at least 18 years old (or legal age of majority in your jurisdiction).</li>
                <li>Have the legal capacity to enter into a binding agreement.</li>
                <li>Provide accurate personal information for identity verification under applicable KYC/AML laws.</li>
              </ul>
              <p>We may deny or terminate access if eligibility requirements are not met.</p>
            </div>

            <div className="terms-section">
              <h3>2. Account Registration & Verification</h3>
              <p>You agree to:</p>
              <ul>
                <li>Provide true, accurate, and complete information.</li>
                <li>Complete KYC verification, including identity documents and address verification.</li>
                <li>Notify us of any material changes to your information.</li>
                <li>Not impersonate another person or open accounts using fraudulent information.</li>
              </ul>
              <p>We may request additional verification to comply with BSA/AML, OFAC, and other regulatory requirements.</p>
            </div>

            <div className="terms-section">
              <h3>3. User Responsibilities</h3>
              <p>You agree not to:</p>
              <ul>
                <li>Use the Services for unlawful or prohibited activities.</li>
                <li>Conduct fraud, money laundering, or suspicious activities.</li>
                <li>Interfere with or disrupt system operations.</li>
                <li>Attempt unauthorized access to systems, networks, or accounts.</li>
              </ul>
              <p>You must monitor your account regularly and report unauthorized activity immediately.</p>
            </div>

            <div className="terms-section">
              <h3>4. Security & Authentication</h3>
              <p>You are responsible for:</p>
              <ul>
                <li>Maintaining confidentiality of login credentials, passkeys, and MFA authentication.</li>
                <li>Not sharing passwords or device access.</li>
                <li>Ensuring your device is secure, updated, and free from malware.</li>
              </ul>
              <p>We use reasonable administrative, technical, and physical safeguards, but cannot guarantee absolute security. You authorize the Bank to act on instructions received through authenticated sessions.</p>
            </div>

            <div className="terms-section">
              <h3>5. Electronic Communications & E-Sign Consent</h3>
              <p>By using our Services, you consent to:</p>
              <ul>
                <li>Receive disclosures, notices, agreements, and statements electronically.</li>
                <li>Conduct transactions using electronic signatures compliant with the E-SIGN Act.</li>
              </ul>
              <p>You may withdraw consent at any time, which may limit access to digital services.</p>
            </div>

            <div className="terms-section">
              <h3>6. Banking Transactions</h3>
              <p>You authorize the Bank to process:</p>
              <ul>
                <li>Deposits</li>
                <li>Withdrawals</li>
                <li>Transfers</li>
                <li>ACH debits/credits</li>
                <li>Card transactions</li>
                <li>Bill payments</li>
              </ul>
              <p>Processing times may vary and are subject to compliance reviews. The Bank may decline or hold transactions if:</p>
              <ul>
                <li>Required by law</li>
                <li>Suspicious activity is detected</li>
                <li>Insufficient funds exist</li>
                <li>System outages occur</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>7. Fees & Charges</h3>
              <p>You agree to pay all applicable fees outlined in the Fee Schedule, including:</p>
              <ul>
                <li>Monthly account fees</li>
                <li>Overdraft fees (if applicable)</li>
                <li>Transfer fees</li>
                <li>ATM fees</li>
                <li>Foreign transaction fees</li>
              </ul>
              <p>Fees may be updated with notice.</p>
            </div>

            <div className="terms-section">
              <h3>8. Prohibited Activities</h3>
              <p>You may not use the Services for:</p>
              <ul>
                <li>Fraud, scams, chargeback schemes</li>
                <li>OFAC-restricted transactions</li>
                {/* <li>Cryptocurrency transactions (unless explicitly permitted)</li> */}
                <li>High-risk merchant activities</li>
                <li>Abuse of promotions or bonuses</li>
              </ul>
              <p>Violation may result in account closure or legal action.</p>
            </div>

            <div className="terms-section">
              <h3>9. Intellectual Property</h3>
              <p>All logos, software, app interfaces, branding, and documentation are property of the Bank. You may not copy, modify, reverse-engineer, or distribute our intellectual property.</p>
            </div>

            <div className="terms-section terms-privacy-disclosures">
              <h3>10. Privacy &amp; Data Use – U.S. Consumer Privacy Notice (Privacy Disclosures)</h3>

              <p className="terms-intro">
                The types of personal information we collect and share depend on the product or service you have with us. This information can include:
              </p>
              <ul>
                <li>Social Security number</li>
                <li>Account balances</li>
                <li>Payment history</li>
                <li>Transactional history</li>
                <li>Credit history</li>
                <li>Wire transfer instructions</li>
              </ul>
              <p>Financial companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share, and protect your personal information. Please read this notice carefully to understand what we do.</p>

              <h4 className="terms-privacy-facts-title">What does GN Bank do with your personal information? Facts</h4>
              <div className="terms-privacy-table">
                <table className="terms-table">
                  <thead>
                    <tr>
                      <th>Reasons we can share your personal information</th>
                      <th>Does GN Bank share?</th>
                      <th>Can you limit this sharing?</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>For our everyday business purposes – such as to process your transactions, maintain your account(s), respond to court orders and legal investigations, or report to credit bureaus</td>
                      <td>Yes</td>
                      <td>No</td>
                    </tr>
                    <tr>
                      <td>For our marketing purposes – to offer our products and services to you</td>
                      <td>No</td>
                      <td>We don't share</td>
                    </tr>
                    <tr>
                      <td>For joint marketing with other financial companies</td>
                      <td>No</td>
                      <td>We don't share</td>
                    </tr>
                    <tr>
                      <td>For our affiliates' everyday business purposes – information about your transactions and experiences</td>
                      <td>Yes</td>
                      <td>No</td>
                    </tr>
                    <tr>
                      <td>For our affiliates' everyday business purposes – information about your creditworthiness</td>
                      <td>No</td>
                      <td>We don't share</td>
                    </tr>
                    <tr>
                      <td>For nonaffiliates to market to you</td>
                      <td>No</td>
                      <td>We don't share</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="terms-privacy-table">
                <table className="terms-table">
                  <thead>
                    <tr>
                      <th>What we do</th>
                      <th></th></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Who is providing this notice?</td>
                      <td>GN Bank, located in Chicago.</td>
                      
                    </tr>
                    <tr>
                      <td>How does GN Bank
                      protect my personal information?</td>
                      <td>To protect your personal information from unauthorized access and use, we use security measures that comply with federal law. These measures include computer safeguards and secured files and buildings.
We also maintain other physical, electronic and procedural safeguards to
protect this information and we limit access to information to those
employees for whom access is appropriate. </td>
                      
                    </tr>
                    <tr>
                      <td>How does GN Bank
                      collect my personal information?</td>
                      <td>We collect your personal information, for example, when you
                        <ul>
                          <li>Open an account</li>
                          <li>Apply for a loan</li>
                          <li>Give us your income information</li>
                          <li>Give us your wage statements</li>
                          <li>Make a wire transfer</li>
                          <li>We also collect your personal information from others, such as credit bureaus, affiliates, or other companies.</li>
                        </ul>
                      </td>
                     
                    </tr>
                    <tr>
                      <td>Why can't I limit all sharing?</td>
                      <td>
                        Federal law gives you the right to limit only 
                        <ul>
                          <li>(1) sharing for affiliates' everyday business purposes – information about your creditworthiness;</li>
                          <li>(2) affiliates from using your information to market to you;</li>
                          <li>(3) sharing for nonaffiliates to market to you.</li>
                          <li>State laws and individual companies may give you additional rights to limit sharing.</li>
                        </ul>
                        </td>
                      
                    </tr>
                    {/* <tr>
                      <td>For our affiliates' everyday business purposes – information about your creditworthiness</td>
                      <td>We don't share</td>
                     
                    </tr>
                    <tr>
                      <td>For nonaffiliates to market to you</td>
                      <td>We don't share</td>
                      
                    </tr> */}
                  </tbody>
                </table>
              </div>








{/* 

              <p><strong>Questions?</strong> Call 773-624-2000 or go to <a href="https://www.gnbank.net" rel="noopener noreferrer">www.gnbank.net</a></p>
              <p>When you are no longer a customer, we continue to share your information as described in this notice.</p>
              <p>All financial companies need to share customers' personal information to run their everyday business. In the section below, we list the reasons financial companies can share their customers' personal information; the reasons GN Bank chooses to share; and whether you can limit this sharing.</p> */}

              <h4>Definitions</h4>
              <ul>
                <li><strong>Affiliates</strong> – Companies related by common ownership or control. They can be financial and nonfinancial companies. Nonfinancial companies such as: GN Bank Safe Deposit Box, Inc. and Metropolitan Service Corporation.</li>
                <li><strong>Nonaffiliates</strong> – Companies not related by common ownership or control. They can be financial and nonfinancial companies.</li>
                <li><strong>Joint marketing</strong> – A formal agreement between nonaffiliated financial companies that together market financial products or services to you.</li>
              </ul>

              {/* <h4>Why can't I limit all sharing?</h4>
              <p>Federal law gives you the right to limit only (1) sharing for affiliates' everyday business purposes – information about your creditworthiness; (2) affiliates from using your information to market to you; (3) sharing for nonaffiliates to market to you. State laws and individual companies may give you additional rights to limit sharing.</p>
              <p>GN Bank does not share with nonaffiliates so they can market to you. GN Bank doesn't jointly market.</p>

              <h4>How does GN Bank collect my personal information?</h4>
              <p>We collect your personal information, for example, when you:</p> */}
              {/* <ul>
                <li>Open an account</li>
                <li>Apply for a loan</li>
                <li>Give us your income information</li>
                <li>Give us your wage statements</li>
                <li>Make a wire transfer</li>
              </ul> */}
              <p>We also collect your personal information from others, such as credit bureaus, affiliates, or other companies.</p>
{/* 
              <h4>How does GN Bank protect my personal information?</h4>
              <p>To protect your personal information from unauthorized access and use, we use security measures that comply with federal law. These measures include computer safeguards and secured files and buildings. We also maintain other physical, electronic and procedural safeguards to protect this information and we limit access to information to those employees for whom access is appropriate.</p> */}

              {/* <h4>What we do</h4>
              <p>To protect your personal information from unauthorized access and use, we use security measures that comply with federal law. These measures include computer safeguards and secured files and buildings.</p>
              <h4>Who is providing this notice?</h4>
              <p>GN Bank, located in Chicago.</p>
              <h4>Who we are</h4>
              <p>We also maintain other physical, electronic and procedural safeguards to protect this information and we limit access to information to those employees for whom access is appropriate.</p> */}

              <h4>Other Important Information</h4>
              <p><strong>For Alaska, Illinois, Maryland and North Dakota Customers.</strong> We will not share your personal information with nonaffiliates either for them to market to you or for joint marketing – without your authorization.</p>
              <p><strong>For California Customers.</strong> We will not share personal information with nonaffiliates either for them to market to you or for joint marketing – without your authorization. We will also limit our sharing of personal information about you with our affiliates to comply with California privacy laws that apply to us.</p>
              <p><strong>For Massachusetts, Mississippi, and New Jersey Customers.</strong> We will not share personal information from deposit or share relationships with nonaffiliates either for them to market to you or for joint marketing – without your authorization.</p>
              <p><strong>For Vermont Members/Customers.</strong> We will not disclose information about your creditworthiness to our affiliates and will not disclose your personal information, financial information, credit report, or health information to nonaffiliated third parties to market to you, other than as permitted by Vermont law, unless you authorize us to make those disclosures.</p>

              <h4>Questions?</h4>
              <p>Call <strong>773-624-2000</strong> or go to <a href="https://www.gnbank.net" rel="noopener noreferrer">www.gnbank.net</a>. Additional information concerning our privacy policies can be found at <a href="https://www.gnbank.net" rel="noopener noreferrer">www.gnbank.net</a> or call 773-624-2000.</p>
              <p><strong>Rev. {new Date().getFullYear()}</strong></p>
            </div>

            <div className="terms-section">
              <h3>11. Third-Party Services</h3>
              <p>Our Services may integrate with third-party providers such as:</p>
              <ul>
                <li>Payment processors</li>
                <li>Credit bureaus</li>
                <li>Verification partners</li>
                <li>Card networks</li>
                <li>Banking-as-a-Service partners</li>
              </ul>
              <p>We are not responsible for failures or errors caused by these providers.</p>
            </div>

            <div className="terms-section">
              <h3>12. Service Availability</h3>
              <p>We strive for 24/7 service uptime but do not guarantee uninterrupted access. Maintenance, outages, or unforeseen technical issues may occur. We are not liable for delays outside our control.</p>
            </div>

            <div className="terms-section">
              <h3>13. Limitation of Liability</h3>
              <p>To the maximum extent permitted by law:</p>
              <ul>
                <li>The Bank is not liable for indirect, incidental, special, or consequential damages.</li>
                <li>Total liability is limited to the amount paid by you for Services in the preceding 12 months.</li>
                <li>Nothing in this section limits liability for fraud or intentional misconduct.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>14. Indemnification</h3>
              <p>You agree to indemnify and hold harmless the Bank from claims, losses, and damages resulting from:</p>
              <ul>
                <li>Your misuse of the Services</li>
                <li>Violation of these Terms</li>
                <li>Third-party claims arising from your actions</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>15. Account Suspension & Termination</h3>
              <p>The Bank may suspend or close your account if:</p>
              <ul>
                <li>Laws or regulations require it</li>
                <li>Fraud or suspicious activity is detected</li>
                <li>You violate these Terms</li>
                <li>Required verification is not completed</li>
              </ul>
              <p>You may close your account at any time unless prohibited by ongoing investigations.</p>
            </div>

            <div className="terms-section">
              <h3>16. Dispute Resolution</h3>
              <p>Disputes will be resolved through:</p>
              <ul>
                <li>Internal dispute review</li>
                <li>Binding arbitration under FAA rules, unless prohibited by law</li>
              </ul>
              <p>No class-action lawsuits are permitted. You agree to resolve disputes individually.</p>
            </div>

            <div className="terms-section">
              <h3>17. Governing Law</h3>
              <p>These Terms are governed by:</p>
              <ul>
                <li>Federal banking laws</li>
                <li>Applicable state financial regulations</li>
                <li>Local jurisdiction where the Bank is chartered or operates</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>18. Changes to These Terms</h3>
              <p>The Bank may update these Terms at any time. Continued use of the Services after any modification constitutes acceptance of the updated Terms.</p>
            </div>


            <div className="terms-section">
              <h3>19. Account Agreements & Disclosures</h3>
              
              <h4>Accounts We Offer</h4>
              <ul>
                <li>Personal Checking (non-interest bearing unless otherwise disclosed), minimum to open: $100; monthly maintenance fee: $15 (see Schedule of Fees for any special account features/waivers).</li>
                <li>Statement Savings (may be interest-bearing as disclosed in our rate sheet), minimum open: $250.00; monthly maintenance fee: $15. Rate: 0.010%</li>
                <li>Money Market Deposit Account (MMDA) (may be interest-bearing), minimum open: $2,500; monthly maintenance fee: $15. Rate: 0.030%</li>
                <li>Promotional Savings Account, minimum open is $2,500 and monthly maintenance fee is $15.00. Rate: 3.6%</li>
                <li>Small Business Checking, minimum open: $100; monthly maintenance fee: $25.</li>
                <li> CD Accounts, minimum open: $1,000; Early Withdrawal Fee: 50% of the interest earned on this time of deposit. APY: 4%. **Automatic Renewal: This certificate will automatically renew on the maturity date. The interest rate at renewal will be GN Bank’s prevailing rate for 60 month Time Deposits. Compounding & Crediting Frequency: Simple interest credited to your account on a quarterly basis.  </li>
              </ul>
              <p><strong>Note:</strong> We may add or discontinue accounts at any time. If an account type is discontinued, we may convert your account to the most similar available account after notice.</p>

              <h4>Account Ownership</h4>
              <p>We rely on our records to determine ownership. For joint accounts, all owners are co‑owners with the right of survivorship unless prohibited by law, and each may act alone. For custodial (UTMA/UGMA) and fiduciary accounts, you agree to comply with applicable law. Business accounts must be established and used for business purposes only.</p>

              <h4>Using and Accessing Your Account</h4>
              <p>You can bank with us at our financial center(s), through Online/Mobile Banking, and by telephone banking. The availability of services may vary or be interrupted for maintenance or security reasons.</p>

              <h4>Deposits; Our Right to Reject/Reverse</h4>
              <p>We may accept, for collection only, refuse, or return all or part of any deposit. We may adjust your account to correct errors. If an item you deposit is returned, we may debit your account and any interest credited on that item, even if this overdraws your account. We may reverse credits that were made in error or based on incorrect information.</p>

              <h4>Posting and Processing Order</h4>
              <p>We receive transactions throughout the day and generally determine posting order during nightly processing. We may post credits, holds, and debits in any order permitted by law. The order in which transactions are posted may increase the number of overdrafts or returned items and related fees.</p>

              <h4>Funds Availability (Regulation CC Summary)</h4>
              <ul>
                <li>Our general policy is to make cash and check deposits available no later than the first business day after the day of deposit. Electronic direct deposits and incoming wires are available the day we receive them.</li>
                <li>Longer delays may apply (e.g., new accounts, large deposits, repeatedly overdrawn accounts, suspicious or uncollectible checks, emergencies). We will notify you and tell you when funds will be available. The first $275 of your check deposits will generally be available by the first business day after the day of deposit.</li>
                <li>ATM and remote deposits may be subject to extended availability. See your statement and Online/Mobile Banking for current status of deposits.</li>
                <li>If GN Bank for any reason chooses to implement a case-by-case hold, at least, the first $275 of the held deposit will be made available by the next business day.</li>
                <li>GN Bank may delay funds availability "for a reasonable period of time" because some transactions present a higher level of risk to the financial institution.</li>
                <li>Reasonable period of time is typically defined as one additional business day for on-us checks (for a total of two business days) and five additional business days for other checks (for a total of seven business days).</li>
                <li><strong>New Accounts:</strong> An account is considered new if each individual on the account has not had a transaction at the institution within the previous 30 days, for a period of at least 30 days. For new customers, only the first $6,725 qualifies for the next day availability. The amount over $6,725 will be made available by the ninth business day after the day of deposit.</li>
                <li><strong>Large Deposits:</strong> Under the large deposit exception, only the amount in excess of $6,725 will be held until the seventh business day.</li>
                <li><strong>Redeposited Checks:</strong> Checks of this nature pose a greater risk to the bank because it can be returned the second time. Full amount will be held until the seventh business day. However, the exception will not apply to a check that was re-deposited because it was returned due to a missing endorsement or postdated.</li>
                <li><strong>Reasonable Cause to Doubt Collectability:</strong> If GN Bank reasonably believes it will not receive payment for a check (because the check is more than six months old or because the paying institution has sent a stop payment notice), it will place a hold on the full amount of the deposited item until the seventh business day.</li>
                <li><strong>Emergency Conditions:</strong> Although rarely used, checks that are deposited during situations outside of GN Bank's control, like a power failure or natural disaster, will be held for any length of time, with justification and notice sent to customers.</li>
              </ul>
              <p>In accordance with Regulation CC (12 CFR Part 229) and the bank's internal policies: Any single check exceeding $6,725 is considered a large deposit and may be subject to an extended hold. The bank reserves the right to aggregate multiple checks deposited at the same time. If the total deposit exceeds $6,725, even when individual checks are below the threshold, the deposit may be placed on hold. Customers will be notified whenever a hold is placed on any deposit, whether due to a single large check or aggregated deposit. Notification includes the reason for the hold and the expected availability date.</p>

              <h4>Withdrawals and Paying Items</h4>
              <p>We may pay or return items presented against your account and are not required to examine every item. We may refuse to cash a check payable to you. Stale‑dated (over six months) and postdated checks may be paid unless you place a stop payment.</p>

              <h4>Overdrafts and Returned Items</h4>
              <p>If you do not have enough available funds to cover an item, we may either pay it and overdraw your account (an overdraft item) or return it unpaid (a returned item), at our discretion.</p>
              <ul>
                <li><strong>Overdraft/Returned Item Fees:</strong> See Section 17 (Fees) and the Schedule of Fees for amounts and when they are charged.</li>
                <li>We generally do not charge an overdraft fee on everyday non‑recurring debit card transactions that were authorized when your available balance was sufficient and later settled when insufficient. We may decline one-time debit card or ATM transactions when funds are insufficient.</li>
                <li>You agree to promptly repay us for any overdraft, fees, and other amounts you owe.</li>
              </ul>

              <h4>Stop Payments</h4>
              <p>You may request a stop payment on an unpaid check or ACH item. We require sufficient information (e.g., account number, check number, exact amount, and payee) and a reasonable time to act. Stop payment orders generally expire after 12 months unless renewed. Fees apply.</p>

              <h4>Statements and Notices</h4>
              <p>We provide a periodic statement for checking, savings, and MMDA accounts when there is activity. Promptly review statements and notify us of problems or unauthorized transactions. For most issues you must notify us within 60 days after we make the statement available.</p>

              <h4>Electronic Banking (Regulation E – Personal Accounts)</h4>
              <p>Tell us AT ONCE if your card, PIN, or Online/Mobile Banking credentials are lost or stolen, or if you believe an EFT has been made without your permission. If you tell us within 2 business days, your loss is limited to $50; otherwise up to $500, and more if you wait longer than 60 days after we send your statement. Call 773‑624‑2000 or write to GN Bank, 4619 S King Drive, Chicago, IL 60653. We investigate errors and, when required, provide provisional credit within 2 business days (longer timeframes may apply in limited cases). We do not charge a fee to investigate a reported EFT error where prohibited by law.</p>

              <h4>Wires and ACH (UCC Article 4A/NACHA)</h4>
              <p>Funds transfer you send or receive may be processed via Fedwire or ACH and are subject to applicable system rules and UCC 4A. We currently offer domestic wires only. We may rely on account numbers even if they identify a different name. Fees apply (see Section 17).</p>

              <h4>Our Rights—Setoff; Security Interest; Legal Process; Freezes</h4>
              <p>We may set off or debit your accounts for any amounts you owe us, except where prohibited by law (e.g., tax‑advantaged retirement accounts). We may comply with legal process (e.g., levies, garnishments, subpoenas) and charge a fee. We may freeze or delay transactions if we suspect fraud, irregular activity, or comply with the law.</p>

              <h4>Fees</h4>
              <p><em>See the Schedule of Fees available on GN Bank's Portal (Copilot) for full, current details; selected items summarized below:</em></p>
              
              <h5>Account Fees</h5>
              <ul>
                <li>Personal Checking: Minimum to open $100; Monthly maintenance fee $15; </li>
                <li>Statement Savings: Minimum to open $250.00; Monthly maintenance fee $15. Rate: 0.010%</li>
                <li>Money Market Deposit Account (MMDA): Minimum to open $2,500; Monthly maintenance fee $15. Rate: 0.030%</li>
                <li>Small Business Checking: Minimum to open $100; Monthly maintenance fee $25.</li>
                <li> CD Accounts, minimum open: $1,000; Early Withdrawal Fee: 50% of the interest earned on this time of deposit. APY: 4.00%. **Automatic Renewal: This certificate will automatically renew on the maturity date. The interest rate at renewal will be GN Bank’s prevailing rate for 60 month Time Deposits. Compounding & Crediting Frequency: Simple interest credited to your account on a quarterly basis.  </li>
                ** Actual rates and fees may vary based on federal rate guidance. Always contact customers support for the most current rates/fees.
              </ul>

              <h5>Overdraft & Related</h5>
              <ul>
                <li>Non‑Sufficient Funds (when we pay) — $35.00 per transaction.</li>
                <li>Returned Item Fee (when we return unpaid) — $35.00 per transaction.</li>
                <li>Extended Overdrawn Account Fee — $35.00 charged daily for each day the account remains overdrawn.</li>
                <li>Savings Excess Transaction Fee — $3.00 per transfer when the account exceeds six transfers/withdrawals in a statement period.</li>
              </ul>

              <h5>ATM/Debit</h5>
              <ul>
                <li>Non‑GN Bank ATM usage ("Foreign ATM") — $3.00 per transaction.</li>
                <li>ATM cash withdrawal fee at GN Bank ATMs for non‑GN Bank customers — $3.00 per transaction (if applicable at GN Bank‑owned ATMs used by non‑customers).</li>
              </ul>

              <h5>Wires/Transfers</h5>
              <ul>
                <li>Outgoing domestic wire — $30.00 per transfer.</li>
                <li>Incoming wire — $15.00 per transfer.</li>
                <li>Customer direct transfer — $10.00 per transfer.</li>
              </ul>

              <h5>Documents/Research/Other</h5>
              <ul>
                <li>Stop payment (check, ACH, or electronic payment) — $35.00 per request.</li>
                <li>Account closed within 90 days of opening — $15.00.</li>
                <li>Dormant account — $15.00 per month.</li>
                <li>Check printing — varies by style.</li>
                <li>Duplicate account statement — $8.00 per statement.</li>
                <li>Official bank checks — First check each month $0.00; each additional check $1.00.</li>
                <li>Cashier's Checks — $3.00. $8.00 , effective March 1, 2026 </li>
                {/* <li>Rolled coin purchase — $0.10 per roll.</li> */}
                <li>Non‑customer check cashing — GN Bank does not cash checks for non‑customers.</li>
              </ul>
              <p>We may add or change fees as permitted by law. Operators of non‑GN Bank ATMs and networks may also charge you.</p>

              <h4>Statements, Errors, and Your Duties</h4>
              <p>Promptly review statements and report issues. Except as otherwise provided by law (e.g., for EFTs and substitute checks), you must notify us in writing within 60 days after we make the statement available or you may not recover for later items by the same wrongdoer.</p>

              <h4>Unclaimed Property; Dormancy</h4>
              <p>Accounts may be classified as dormant/inactive under state law and charged a dormancy fee. We escheat abandoned property to the state as required.</p>
              <p><strong>Note:</strong> Account status is changed to dormant when inactive consecutively for six months.</p>

              <h4>Changes, Closing, and Conversion</h4>
              <p>You or we may close an account at any time. We may convert an account to a different type if it no longer meets usage or eligibility criteria, after notice. We may close accounts for misuse, fraud, or threatening/abusive conduct toward employees or customers.</p>

              <h4>Dispute Resolution; Venue</h4>
              <ul>
                <li><strong>Personal Accounts:</strong> Any claim will be resolved in court by a judge without a jury to the extent permitted by law; you and we waive jury trial.</li>
                <li><strong>Business Accounts:</strong> Either party may elect binding arbitration before AAA or JAMS under their rules. No class arbitration or class claims. Venue for court actions and for arbitration will be Cook County, Illinois.</li>
              </ul>

              <h4>Freezing Accounts - Your Account And Delayed Transactions</h4>
              <p>If we decide to close your account, we may freeze it. If we do this, we may in our discretion either accept or return deposits, checks and other items that we receive after we freeze your account without being liable to you. 
              If at any time we believe that your account may be subject to irregular, unauthorized, fraudulent or illegal activity, we may, in our discretion, freeze some or all of the funds in the account and in other accounts you maintain with us, and/or delay transactions, without any liability to you, until such time as we are able to complete our investigation of the account and transactions. If we do freeze your account funds or delay transactions, we will provide notice to you as soon as reasonably possible. Notice may be made by mail or verbally or provided by other means such as via Online Banking or text alerts as permitted by law or by updated balance information. We may not provide this notice to you prior to freezing the account or delaying transactions if we believe that such notice could result in a security risk to us or to the owner of the funds in the account. The Bank will not be liable for any costs or fees incurred by the delay. </p>
              <h4>FDIC Insurance and Pass‑Through Coverage</h4>
              <p>Deposits are insured by the FDIC up to at least $250,000 per depositor, per ownership category. Accounts established by agents or fiduciaries may be eligible for pass‑through insurance when recordkeeping requirements are met.</p>

              <p><strong>This Agreement supersedes prior GN Bank deposit agreements as of the revision date above.</strong></p>
            </div>




            <div className="terms-section">
              <h3>20. Patriot Act</h3>
              <section className="section">
                <div className="gn-container">
                  <div className="patriot-act-content">
                    <p className="patriot-act-intro">
                      To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account.
                    </p>
                    <p className="patriot-act-intro">
                      This notice describes our obligations under the USA PATRIOT Act, and your responsibilities as a customer of GN Bank.
                    </p>

                    <div className="patriot-act-section">
                      <h3>I. Information We Must Collect</h3>
                      <p>When you open an account, we are required by federal law to ask for identifying information such as:</p>
                      <ul>
                        <li>Your full legal name</li>
                        <li>Residential address</li>
                        <li>Date of birth</li>
                        <li>Social Security Number or Taxpayer Identification Number</li>
                        <li>Government-issued photo identification (e.g., driver's license, passport)</li>
                      </ul>
                      <p>For businesses, we may collect:</p>
                      <ul>
                        <li>Legal business name and address</li>
                        <li>Employer Identification Number (EIN)</li>
                        <li>Ownership structure</li>
                        <li>Beneficial owners (per FinCEN's BOI rule)</li>
                        <li>Authorized signers and controlling persons</li>
                      </ul>
                    </div>

                    <div className="patriot-act-section">
                      <h3>II. Additional Verification</h3>
                      <p>To comply with federal regulations and protect customers, we may require additional identity verification, including but not limited to:</p>
                      <ul>
                        <li>Document uploads (ID, utility bill, etc.)</li>
                        <li>Biometric verification (selfie match / liveness check)</li>
                        <li>Credit bureau information</li>
                        <li>Public records</li>
                        <li>Phone number verification</li>
                        <li>IP/geolocation checks</li>
                        <li>Employer or income verification</li>
                        <li>OFAC screening</li>
                      </ul>
                      <p>These steps help ensure your identity is legitimate and help protect the financial system from illicit activity.</p>
                    </div>

                    <div className="patriot-act-section">
                      <h3>III. When Identification Cannot Be Verified</h3>
                      <p>If we are unable to verify your identity:</p>
                      <ul>
                        <li>Your account may not be opened; or</li>
                        <li>Your existing account may be suspended or closed; and</li>
                        <li>Transactions may be delayed or restricted</li>
                      </ul>
                      <p>These actions are mandated by federal law for the safety of the banking system.</p>
                    </div>

                    <div className="patriot-act-section">
                      <h3>IV. Ongoing Monitoring & Compliance</h3>
                      <p>Under the Bank Secrecy Act (BSA) and the USA PATRIOT Act, we must:</p>
                      <ul>
                        <li>Monitor activity for suspicious behavior</li>
                        <li>File required reports (SARs/CTRs) with FinCEN when appropriate</li>
                        <li>Maintain transaction records</li>
                        <li>Conduct periodic re-verification of customer information</li>
                      </ul>
                      <p>We may contact you for updated documents or information at any time.</p>
                    </div>

                    <div className="patriot-act-section">
                      <h3>V. No Opt-Out</h3>
                      <p>These identity verification requirements are not optional. Federal law mandates that all customers provide accurate and complete information.</p>
                      <p>Failure to comply may result in:</p>
                      <ul>
                        <li>Delayed services</li>
                        <li>Account closure</li>
                        <li>Restrictions on transactions</li>
                      </ul>
                    </div>

                    <div className="patriot-act-section">
                      <h3>VI. Protection of Your Information</h3>
                      <p>All collected information is used solely to comply with:</p>
                      <ul>
                        <li>The USA PATRIOT Act</li>
                        <li>BSA/AML regulations</li>
                        <li>OFAC sanctions rules</li>
                        <li>Applicable federal and state banking laws</li>
                      </ul>
                      <p>Your information is safeguarded in accordance with:</p>
                      <ul>
                        <li>GLBA (Gramm–Leach–Bliley Act)</li>
                        <li>Our Privacy Policy</li>
                        <li>FFIEC data security guidelines</li>
                      </ul>
                      <p>We do not sell customer identity information.</p>
                    </div>



                    <div className="patriot-act-footer">
                      <p>We appreciate your cooperation in helping us adhere to federal requirements designed to protect our customers and the financial system.</p>
                    </div>

                    <div className="patriot-act-cta text-center">
                      <a className="btn btn-gn-primary" href="/contact">Contact Compliance</a>
                    </div>
                  </div>
                </div>
              </section>
            </div>





            <div className="terms-section">
              <h3>21.Mortgage Terms and Conditions</h3>
              
              <p className="terms-intro">
                These General Mortgage Terms and Conditions ("Mortgage Terms") apply to all mortgage loans, home equity loans, home equity lines of credit (HELOCs), and other real estate-secured loans ("Mortgage Loans") provided by GN Bank. These terms supplement and are incorporated into your specific mortgage loan documents, including your Note, Mortgage or Deed of Trust, and any other loan agreements.
              </p>

              <h4>21.1 Loan Application and Approval</h4>
              <p>By applying for a Mortgage Loan, you agree to:</p>
              <ul>
                <li>Provide accurate, complete, and truthful information in your application</li>
                <li>Authorize us to verify information through credit bureaus, employers, financial institutions, and other sources</li>
                <li>Provide additional documentation as requested during the application process</li>
                <li>Notify us immediately of any material changes to your financial situation or the property</li>
                <li>Understand that loan approval is subject to underwriting criteria, property appraisal, and verification of information</li>
              </ul>
              <p>We reserve the right to deny, modify, or withdraw any loan offer at any time before closing if we discover material misrepresentations, changes in your financial condition, or other factors that affect your creditworthiness or the property's value.</p>

              <h4>21.2 Interest Rates and Payments</h4>
              <p>Your Mortgage Loan terms, including interest rate, payment amount, and payment schedule, are specified in your Note and loan documents. Key terms include:</p>
              <ul>
                <li><strong>Interest Rate:</strong> The interest rate may be fixed or adjustable as specified in your loan documents. For adjustable-rate loans, the rate may change based on an index plus a margin.</li>
                <li><strong>Payment Amount:</strong> Your monthly payment amount is calculated based on the principal balance, interest rate, and loan term. Payments are due on the date specified in your loan documents.</li>
                <li><strong>Payment Allocation:</strong> Payments are generally applied first to accrued interest, then to principal, then to escrow (if applicable), and finally to any fees or charges.</li>
                <li><strong>Late Payments:</strong> If a payment is not received by the due date, you may be charged a late fee as specified in your loan documents. Late payments may also affect your credit.</li>
                <li><strong>Payment Methods:</strong> You may make payments through online banking, automatic debit, mail, or in person at our branch locations.</li>
              </ul>

              <h4>21.3 Escrow Accounts</h4>
              <p>If your loan requires an escrow account, we will:</p>
              <ul>
                <li>Collect funds with your monthly payment to cover property taxes, homeowners insurance, mortgage insurance (if applicable), and other required charges</li>
                <li>Pay these obligations on your behalf when they become due</li>
                <li>Maintain an escrow account balance as required by law (typically sufficient to cover upcoming payments plus a cushion)</li>
                <li>Provide an annual escrow account analysis statement showing activity and any changes to your payment</li>
              </ul>
              <p>You are responsible for ensuring that property taxes and insurance premiums are paid on time. If your escrow account has insufficient funds, you must make up the shortfall. We may require an escrow account if you have a history of late payments or if required by law or your loan program.</p>

              <h4>21.4 Property Insurance and Taxes</h4>
              <p>You must maintain adequate property insurance and pay all property taxes:</p>
              <ul>
                <li><strong>Hazard Insurance:</strong> You must maintain homeowners insurance (or equivalent) covering the property for at least the replacement cost or the outstanding loan balance, whichever is less. We must be named as mortgagee/loss payee on the policy.</li>
                <li><strong>Flood Insurance:</strong> If the property is in a flood zone, you must maintain flood insurance as required by federal law and your loan documents.</li>
                <li><strong>Property Taxes:</strong> You are responsible for paying all property taxes, assessments, and governmental charges. Failure to pay may result in tax liens that take priority over our mortgage.</li>
                <li><strong>Proof of Insurance:</strong> You must provide proof of insurance upon request and notify us of any policy changes, cancellations, or non-renewals.</li>
                <li><strong>Force-Placed Insurance:</strong> If you fail to maintain required insurance, we may purchase insurance on your behalf and add the cost to your loan balance. This insurance may be more expensive and provide less coverage than insurance you could obtain.</li>
              </ul>

              <h4>21.5 Property Maintenance and Use</h4>
              <p>You agree to:</p>
              <ul>
                <li>Maintain the property in good condition and repair</li>
                <li>Not commit waste or allow the property to deteriorate</li>
                <li>Comply with all applicable laws, ordinances, and regulations</li>
                <li>Not use the property for illegal purposes</li>
                <li>Not create or allow any liens or encumbrances on the property (except as permitted by your loan documents)</li>
                <li>Allow us to inspect the property with reasonable notice</li>
                <li>Notify us of any material damage to the property</li>
              </ul>
              <p>If the property is damaged, insurance proceeds must be used to repair or restore the property, or to pay down the loan, as we may require.</p>

              <h4>21.6 Default and Acceleration</h4>
              <p>You will be in default if you:</p>
              <ul>
                <li>Fail to make any payment when due</li>
                <li>Fail to maintain required insurance or pay property taxes</li>
                <li>Fail to maintain the property or allow it to deteriorate</li>
                <li>Transfer the property without our consent (if required by your loan documents)</li>
                <li>Make false statements in your loan application or documents</li>
                <li>File for bankruptcy or become insolvent</li>
                <li>Violate any other term of your loan documents</li>
              </ul>
              <p>If you are in default, we may:</p>
              <ul>
                <li>Accelerate the loan, making the entire balance immediately due and payable</li>
                <li>Charge late fees, default interest, and collection costs</li>
                <li>Initiate foreclosure proceedings</li>
                <li>Exercise any other rights available under your loan documents or applicable law</li>
              </ul>
              <p>We may accept late payments or partial payments without waiving our right to accelerate or foreclose. You may have rights under federal and state law to cure defaults and avoid foreclosure.</p>

              <h4>21.7 Foreclosure</h4>
              <p>If you default on your Mortgage Loan, we may foreclose on the property:</p>
              <ul>
                <li><strong>Foreclosure Process:</strong> Foreclosure procedures vary by state. We will follow applicable state and federal laws, including providing required notices and opportunities to cure.</li>
                <li><strong>Right to Reinstate:</strong> You may have the right to reinstate your loan by paying all past-due amounts, fees, and costs before a foreclosure sale, as permitted by law.</li>
                <li><strong>Deficiency:</strong> If the foreclosure sale proceeds are insufficient to pay the loan balance and costs, you may be liable for the deficiency, subject to applicable law.</li>
                <li><strong>Redemption Rights:</strong> Some states allow a redemption period after foreclosure during which you may reclaim the property by paying the full amount due.</li>
                <li><strong>Eviction:</strong> After foreclosure, you may be required to vacate the property. We may seek eviction if you do not leave voluntarily.</li>
              </ul>
              <p>Foreclosure is a serious matter that will negatively impact your credit and may result in the loss of your home. We encourage you to contact us immediately if you are having difficulty making payments.</p>

              <h4>21.8 Prepayment</h4>
              <p>You may prepay all or part of your Mortgage Loan at any time:</p>
              <ul>
                <li><strong>Full Prepayment:</strong> You may pay off the entire loan balance at any time. You must pay all principal, accrued interest, and any applicable prepayment fees or charges.</li>
                <li><strong>Partial Prepayment:</strong> You may make additional principal payments. These may reduce your monthly payment or shorten your loan term, depending on your loan terms.</li>
                <li><strong>Prepayment Penalties:</strong> Some loans may have prepayment penalties if you pay off the loan within a specified period (typically the first few years). Your loan documents will specify if prepayment penalties apply.</li>
                <li><strong>Notice:</strong> If you plan to pay off the loan, contact us for a payoff statement showing the exact amount due, including interest through the payoff date.</li>
              </ul>

              <h4>21.9 Transfer of Property and Assumption</h4>
              <p>You may not transfer the property or your interest in the loan without our consent:</p>
              <ul>
                <li><strong>Due-on-Sale Clause:</strong> Most mortgages contain a "due-on-sale" clause that allows us to accelerate the loan if you transfer the property without our consent.</li>
                <li><strong>Permitted Transfers:</strong> Some transfers may be permitted, such as transfers to family members, transfers into trusts, or transfers that do not change occupancy, subject to our approval and applicable law.</li>
                <li><strong>Loan Assumption:</strong> A new borrower may assume your loan only with our written approval and satisfaction of our underwriting criteria. Assumption fees may apply.</li>
                <li><strong>Release of Liability:</strong> If a new borrower assumes your loan, you may be released from liability only if we agree in writing. Otherwise, you remain liable for the loan even after transfer.</li>
              </ul>

              <h4>21.10 Loan Modifications and Workouts</h4>
              <p>If you are experiencing financial hardship, we may offer loan modification or workout options:</p>
              <ul>
                <li><strong>Loan Modification:</strong> We may modify your loan terms (e.g., interest rate, payment amount, loan term) to help you avoid foreclosure. Modifications are subject to approval and may require documentation of hardship.</li>
                <li><strong>Forbearance:</strong> We may temporarily reduce or suspend payments for a specified period. Forborne amounts must be repaid, typically through a repayment plan or loan modification.</li>
                <li><strong>Short Sale:</strong> We may agree to accept less than the full loan balance if the property is sold, subject to approval and applicable requirements.</li>
                <li><strong>Deed in Lieu:</strong> We may accept a deed to the property in lieu of foreclosure, subject to approval and applicable requirements.</li>
              </ul>
              <p>These options are not guaranteed and are evaluated on a case-by-case basis. Contact us as soon as possible if you are having difficulty making payments.</p>

              <h4>21.11 Private Mortgage Insurance (PMI)</h4>
              <p>If your loan requires private mortgage insurance (PMI):</p>
              <ul>
                <li><strong>PMI Requirements:</strong> PMI is typically required if your down payment is less than 20% of the property value. PMI protects the lender, not you, in case of default.</li>
                <li><strong>PMI Cancellation:</strong> Under federal law, you may request cancellation of PMI when your loan balance reaches 80% of the original property value, based on the original purchase price or appraised value. We must automatically cancel PMI when the balance reaches 78% of the original value, if you are current on payments.</li>
                <li><strong>PMI Premiums:</strong> PMI premiums are added to your monthly payment or paid separately, as specified in your loan documents.</li>
              </ul>

              <h4>21.12 Home Equity Loans and HELOCs</h4>
              <p>If you have a home equity loan or home equity line of credit (HELOC), additional terms apply:</p>
              <ul>
                <li><strong>Draw Period:</strong> HELOCs typically have a draw period (e.g., 10 years) during which you can borrow funds, followed by a repayment period.</li>
                <li><strong>Variable Rates:</strong> HELOCs typically have variable interest rates that may change based on an index.</li>
                <li><strong>Minimum Draws:</strong> Some HELOCs may have minimum draw requirements or fees for inactivity.</li>
                <li><strong>Payment Requirements:</strong> During the draw period, you may be required to make interest-only payments. During the repayment period, you must pay principal and interest.</li>
                <li><strong>Line Reductions:</strong> We may reduce or suspend your credit line if the property value declines, your creditworthiness deteriorates, or other circumstances warrant, as permitted by your agreement.</li>
              </ul>

              <h4>21.13 Fees and Charges</h4>
              <p>You may be charged various fees in connection with your Mortgage Loan, including:</p>
              <ul>
                <li>Origination fees and points</li>
                <li>Appraisal and property inspection fees</li>
                <li>Title insurance and recording fees</li>
                <li>Late payment fees</li>
                <li>Returned payment fees</li>
                <li>Payoff statement fees</li>
                <li>Assumption fees (if applicable)</li>
                <li>Modification fees (if applicable)</li>
                <li>Other fees as specified in your loan documents</li>
              </ul>
              <p>All fees are disclosed in your loan estimate, closing disclosure, and loan documents. Contact us for current fee information.</p>

              <h4>21.14 Notices and Communications</h4>
              <p>We will send notices and communications to the address you provide:</p>
              <ul>
                <li>You must notify us immediately of any change of address</li>
                <li>Notices are effective when mailed or sent electronically (if you have consented to electronic delivery)</li>
                <li>You are responsible for keeping your contact information current</li>
                <li>Important notices may be sent by certified mail or other methods as required by law</li>
              </ul>

              <h4>21.15 Governing Law and Dispute Resolution</h4>
              <p>These Mortgage Terms are governed by:</p>
              <ul>
                <li>Federal laws, including the Truth in Lending Act (TILA), Real Estate Settlement Procedures Act (RESPA), and other applicable federal mortgage laws</li>
                <li>State laws where the property is located</li>
                <li>State laws where GN Bank is chartered or operates</li>
              </ul>
              <p>Disputes related to your Mortgage Loan may be subject to:</p>
              <ul>
                <li>Mandatory arbitration (if specified in your loan documents)</li>
                <li>Court proceedings in the jurisdiction where the property is located or where GN Bank operates</li>
                <li>Class action waivers (if specified in your loan documents)</li>
              </ul>

              <h4>21.16 Changes to These Terms</h4>
              <p>We may update these General Mortgage Terms and Conditions from time to time. Material changes will be communicated to you as required by law. Your specific loan documents (Note, Mortgage, etc.) govern your individual loan and may not be changed without your consent, except as permitted by law or your loan documents.</p>

              <h4>21.17 Contact Information for Mortgage Inquiries</h4>
              <p>For questions about your Mortgage Loan, payment issues, or loan modifications, contact us:</p>
              <p>
                GN Bank<br />
                Credit Department<br />
                4619 S. King Drive, Chicago, IL 60653<br />
                Phone: (773) 624-2000<br />
                Website: https://gnbank.net
              </p>
              <p><strong>Last Updated:</strong> January 2026</p>
            </div>

            <div className="terms-section">
              <h3>22. Contact Information</h3>
              <p>For questions or legal notices:</p>
              <p>
                GN Bank<br />
                4619 S. King Drive, Chicago, IL 60653<br />
                https://gnbank.net<br />
               (773) 624-2000<br />
               Mon - Fri: 10:00 AM - 3:00 PM<br />
               Wed:  8:30 AM - 12:00 PM<br />
               Sat: 8:30 AM - 12:00 PM<br />
               Sun: Closed<br />
               Excluding federal holidays.
              </p>
            </div>

            <div className="terms-cta text-center terms-no-print">
              <a className="btn btn-gn-primary" href="/contact">Request full policy</a>
            </div>
          </div>
        </div>
      </section>

      {/* Print-only: document footer with website link */}
      <div className="terms-print-footer" aria-hidden="true">
        <span className="terms-print-code">{code}</span>
        <a href={WEBSITE_URL} rel="noopener noreferrer">{WEBSITE_URL}</a>
      </div>
    </div>
  );
};

export default Termsofuse;
